import type { SpotPriser } from "$lib/types/spotPriser";
import theTime from "$lib/utils/the-time";
import { getPriceWithAreaMva, getPriceWithStromstotte as getStottePrice } from "$lib/utils/spotPriceOut";
import { type AreaCode, isAreaCode } from "$lib/utils/areaUtils";

type FetchTimesprisOptions = RequestInit & {
  date?: string | Date;
};

export default async function fetchSpotprisTime(
  opt: FetchTimesprisOptions = {},
  sveltekitServerFetch?: typeof fetch
) {
  const date = opt.date ? theTime(opt.date) : theTime();
  const today = date.toPlainDateString();
  const tomorrow = theTime(date).goes({ DD: +1 }).toPlainDateString();
  const apiUrl = `https://api.servicekanal.no/spotpriser/fradatotildato/${today}/${tomorrow}`;
  const fetchOptions = opt && Object.keys(opt).length > 0 ? opt : {};

  try {
    const res = sveltekitServerFetch ? await sveltekitServerFetch(apiUrl) : await fetch(apiUrl, fetchOptions);
    const allPrices: SpotPriser[] = await res.json();

    const allPricesMva = allPrices.map((area) => {
      return {
        ...area,
        dager: area.dager.map((infoDay) => {
          return {
            ...infoDay,
            priser: infoDay.priser.map((priceInfo) => {
              return {
                ...priceInfo,
                pris: getPriceWithAreaMva(priceInfo.pris, area.omrade as AreaCode),
                priceRaw: priceInfo.pris,
                hasStromstottePris: ((price = priceInfo.pris, areaCode: string = area.omrade) => {
                  if (!isAreaCode(areaCode)) return null;

                  const area = areaCode as AreaCode;
                  const prisStromstotte = getStottePrice(
                    price,
                    area,
                    new Date(infoDay.dato)
                  );

                  // Return null if prisStromstotte is the same as pris
                  if (getPriceWithAreaMva(price, area) === prisStromstotte)
                    return null;
                  else
                    return prisStromstotte;
                })(),
              };
            }),
          };
        }),
      };
    });

    return {
      spotPriser: allPricesMva,
    };
  } catch (error) {
    return {
      error: true,
      message: "Sportpriser er utilgjengelig for øyeblikket. Prøv igjen senere.",
      errorMessage: String(error),
    };
  }
}
